import AssetManager from '~/utils/assets/AssetManager'

export const useAssetManager = () => {
  const runtimeConfig = useRuntimeConfig()

  return {
    getQuoteBenefits: () => AssetManager.getQuoteBenefits(runtimeConfig),
    getOrderForm: () => AssetManager.getOrderForm(runtimeConfig),
    getHowItWorks: () => AssetManager.getHowItWorks(runtimeConfig),
    getLogos: () => AssetManager.getLogo(runtimeConfig),
    getFacebookLogo: () => AssetManager.getFbLogo(runtimeConfig),
    getUspImages: () => AssetManager.getUspImages(runtimeConfig),
    getBenefits: () => AssetManager.getBenefits(runtimeConfig),
    getProHowItWorks: () => AssetManager.getProHowItWorks(runtimeConfig),
  }
}
